import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { splitPrice } from "@/utils/price.utils";

export const formatPriceForEcommerce = (price: number) => {
    const splitted = splitPrice(price);
    return `${splitted[0]},${splitted[1] === "00" ? "-" : splitted[1]}`;
};

type Props = {
    className?: string;
    children: ReactNode;
};

const DeliveryItemBase = ({ className, children }: Props) => {
    return <div className={cn(className)}>{children}</div>;
};

export { DeliveryItemBase };
